export default __webpack_public_path__ + "static/media/ufal.584c4663.svg";